/**
 * Created by Roman T on 3/24/2017.
 */
//const dcItemBindings: { [bindngs: string]: string } = { item: '=', row: '<', comp: '<', filter: '=' };
var DetailEligibilityFindcmrCommentsController = (function () {
    function DetailEligibilityFindcmrCommentsController(topic, settings, env, socket, $scope, $attrs) {
        this.topic = topic;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.newComment = '';
    }
    DetailEligibilityFindcmrCommentsController.prototype.showHide = function () {
        this.show = this.show ? false : true;
    };
    DetailEligibilityFindcmrCommentsController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
        }
        else {
            this.section = 'findCmr'; //Should not happen! But if so, all will be added to Elig tab
        }
    };
    DetailEligibilityFindcmrCommentsController.prototype.addCmrComment = function () {
        var objectPath = 'comments.' + this.section; //apply to Elig tab comments or Validation tab accordingly
        var data = {
            id: this.topic.topic._id,
            data: (_a = {},
                //['comments.findCmr']: {
                _a[objectPath] = {
                    push: true,
                    data: [{
                            comment: this.newComment,
                            user: this.env.user.email,
                            source: this.env.user.email,
                            time: new Date().getTime(),
                            section: this.section
                        }]
                },
                _a
            ),
            type: ['comments']
        };
        this.topic.updateServerTopic('updateCoreComments', data, true);
        this.newComment = '';
        var _a;
    };
    DetailEligibilityFindcmrCommentsController.$inject = ['topic', 'settings', 'env', 'socket', '$scope', '$attrs'];
    return DetailEligibilityFindcmrCommentsController;
}());
var DetailEligibilityFindcmrCommentsComponent = (function () {
    function DetailEligibilityFindcmrCommentsComponent() {
        this.templateUrl = 'detail-eligibility-findcmr-comments.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityFindcmrCommentsController;
    }
    return DetailEligibilityFindcmrCommentsComponent;
}());
angular
    .module('application')
    .component('detailEligibilityFindcmrComments', new DetailEligibilityFindcmrCommentsComponent());

//# sourceMappingURL=detail-eligibility-findcmr-comments.component.js.map
